import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AttachmentItem, AttachmentTypeID} from '../../../api/entity/attachment';


@Component({
    selector: 'tfl-files-download',
    template: require('./files.download.template.html')
})
export class FilesDownloadComponent {
    @Input('title') title: string;
    @Input('buttonName') buttonName: string;
    @Input('attachments') attachments: AttachmentItem[];
    @Input() disableSaveAll = false;

    @Output() downloadFile = new EventEmitter<any>();
    @Output() downloadFiles = new EventEmitter<AttachmentTypeID>();

    constructor() {

    }

    downloadAttachments(typeId) {
        this.downloadFiles.emit(typeId);
    }

    downloadAttachment(fileId: string) {
        this.downloadFile.emit(fileId);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/file/download/files.download.component.ts